<template>
<div>
  <div class="custom-sidebar">
    <side-bar>
        <template slot="links">
          <sidebar-item :link="{name: 'Home',
                                icon: 'home',
                                path: '/'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Regiones',
                                icon: 'language',
                                path: '/regiones'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Comparativa',
                                icon: 'timeline',
                                path: '/comparativa'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Cultivos',
                                icon: 'spa',
                                path: '/cultivos'}" @click="linkClick">
          </sidebar-item>
          <sidebar-item :link="{name: 'Precios',
                                icon: 'attach_money',
                                path: '/precios'}" @click="linkClick">

          </sidebar-item>
        </template>
    </side-bar>
  </div>
  <div class="full-page md-custom-navbar" :class="{'nav-open': $sidebar.showSidebar}">
    <md-toolbar
      md-elevation="0"
      class="md-transparent"
      :class="{'md-toolbar-absolute md-white md-fixed-top': $route.meta.navbarAbsolute}">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start header-logo">
          <router-link to="/"><h3>Ag<strong>BI</strong></h3></router-link>
        </div>
        <div class="md-toolbar-section-end">
          <div class="md-group pull-left">
            <drop-down direction="down">
              <md-button slot="title" class="md-button md-success md-sm dropdown-toggle" data-toggle="dropdown">
                {{campaignSelected}}
              </md-button>
              <ul class="dropdown-menu dropdown-menu-left">
                <li><a class="pointer" @click="changeCampaign(1)">{{campaignList[0]}}</a></li>
                <li><a class="pointer" @click="changeCampaign(2)">{{campaignList[1]}}</a></li>
                <li><a class="pointer" @click="changeCampaign(3)">{{campaignList[2]}}</a></li>
<!--                <li><a class="pointer" @click="changeCampaign(4)">{{campaignList[3]}}</a></li>-->
<!--                <li><a class="pointer" @click="changeCampaign(5)">{{campaignList[4]}}</a></li>-->
              </ul>
            </drop-down>
          </div>
          <md-button class="md-just-icon md-round md-simple md-toolbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
          <div class="md-collapse">
            <md-list>
              <md-list-item to="/" @click="linkClick">
                    <md-icon>home</md-icon>
                    Home
                </md-list-item>
                <md-list-item to="/regiones" @click="linkClick">
                    <md-icon>language</md-icon>
                    Regiones
                </md-list-item>
                <md-list-item to="/comparativa" @click="linkClick">
                    <md-icon>timeline</md-icon>
                    Comparativa
                </md-list-item>
                <md-list-item to="/cultivos" @click="linkClick">
                    <md-icon>spa</md-icon>
                    Cultivos
                </md-list-item>
                <md-list-item to="/precios" @click="linkClick">
                    <md-icon>attach_money</md-icon>
                    Precios
                </md-list-item>
            </md-list>
          </div>
        </div>
      </div>
    </md-toolbar>
  </div>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
  computed: {
    ...mapState(['campaignList', 'campaignSelected'])
  },
  methods: {
    ...mapActions(['changeCampaign']),
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    linkClick() {
      if (this.$sidebar && this.$sidebar.showSidebar === true) {
        this.$sidebar.displaySidebar(false)
      }
    },

    closeMenu() {
      document.body.classList.remove('nav-open')
      this.showMenu = false
    },

  }
}
</script>
<style>
.md-custom-navbar{
  background-color: #0061ad !important;
  border-radius: 0;
  position: fixed;
  z-index:999;
  right: 0;
  left:0;
  top:0;
}

.md-custom-navbar i{
  color:white !important;
}
.pointer{
  cursor: pointer;
}
.header-logo h3{
  font-size:32px;
  color: white;
  margin: 0;
}

.main-panel > .content{
  padding: 15px;
  padding-top: 0;
  margin-top:68px;
}
.md-layout.layout-margin{
  padding-top:40px;
}

@media (min-width: 992px) {
  .custom-sidebar {
    display:none;
  }
}

</style>
